import React from 'react';
import {
  SandboxApiKeys,
  TryItOut,
  CustomiseCheckout,
  WebhooksSetup,
  SandboxIntegration,
  PaymentMethods,
  WhitelistDomain,
  ProductionApiKeys,
  UpdateWebhookUrl,
  UpdateBaseApi,
  ConfirmBankDetail,
} from '../components/Steps';
import { CheckoutStep } from '../types';
import {
  CASHFREE_DOCS_GATEWAY_END_POINTS,
  INTEGRATION_STATUS,
  IntegrationEvents,
} from './constant';

export const steps: CheckoutStep[] = [
  {
    id: 1,
    title: 'Integrate Checkout in Sandbox',
    nextStep: 'Verify Key Details before we move to Production',
    subSteps: [
      {
        id: IntegrationEvents.SBOX_API_KEYS,
        label: 'Procure Sandbox API Keys',
        description:
          'Generate and copy Sandbox API keys to a secure environment. We will use it in the next step.',
        component: SandboxApiKeys,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
      {
        id: IntegrationEvents.SBOX_FIRST_TXN,
        label: 'Integrate in Sandbox',
        description:
          'Connect your application to our sandbox environment using the API keys.',
        component: SandboxIntegration,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
      {
        id: IntegrationEvents.SBOX_WEBHOOKS,
        label: 'Set-up Webhooks',
        description:
          'Configure webhooks to receive real-time updates about transactions and events.',
        component: WebhooksSetup,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
    ],
  },
  {
    id: 2,
    title: 'Verify Key Details',
    nextStep: 'Integrate Cashfree Checkout in Production',
    subSteps: [
      {
        id: IntegrationEvents.WHITELIST_SITE,
        label: 'Whitelist site/package',
        description:
          'This is the domain/package you shared at signup—Cashfree would allow transactions happening only on this domain/package.',
        component: WhitelistDomain,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
      {
        id: IntegrationEvents.PAYMENT_METHODS,
        label: 'Check Payment Methods',
        description: 'These payment methods are enabled for your business.',
        component: PaymentMethods,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
      {
        id: IntegrationEvents.SETTLEMENT_BANK_DETAILS,
        label: 'Confirm Settlement Bank Details',
        description: 'Confirm Settlement Bank Details for your business.',
        component: ConfirmBankDetail,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
    ],
  },
  {
    id: 3,
    title: 'Integrate Checkout in Production',
    nextStep: 'Set up your first transaction',
    subSteps: [
      {
        id: IntegrationEvents.PROD_API_KEYS,
        label: 'Procure Production API Keys',
        description:
          "Let's move your sandbox integration to production by copying the production API keys. Please store them securely.",
        component: ProductionApiKeys,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
      {
        id: IntegrationEvents.PROD_FIRST_TXN,
        label: 'Update Base API/SDK',
        description: (
          <>
            Update your base urls/packages for production environment as
            provided{' '}
            <a
              href={CASHFREE_DOCS_GATEWAY_END_POINTS}
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
          </>
        ),
        component: UpdateBaseApi,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
      {
        id: IntegrationEvents.PROD_WEBHOOKS,
        label: 'Update Webhook URL',
        description:
          'Update your webhook endpoints to production environment to listen to key events real-time',
        component: UpdateWebhookUrl,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
    ],
  },
  {
    id: 4,
    title: 'Complete your first transaction',
    subSteps: [
      {
        id: IntegrationEvents.CUSTOMISE_CHECKOUT,
        label: 'Customise Checkout',
        description:
          'Customise checkout by adding your logo & brand colours to make it feel truly yours.',
        component: CustomiseCheckout,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
      {
        id: IntegrationEvents.TRY_IT_OUT,
        label: "Let's try it out",
        description: `Your integration is now complete. Let's verify it by opening your $platfrom in production and attempting a payment.`,
        component: TryItOut,
        isComplete: INTEGRATION_STATUS.NOT_COMPLETED,
      },
    ],
  },
];
